/**
 * FooterColumn — a single menu column with heading and links.
 * Used on desktop/tablet layouts.
 */

import { Link } from 'react-router-dom';
import type { FooterMenuColumn } from '../../types/footer';

export function FooterColumn({ column }: { column: FooterMenuColumn }): JSX.Element {
  return (
    <div>
      <h5 className="font-display font-semibold text-slate-900 dark:text-white text-sm tracking-wide mb-4">
        {column.label}
      </h5>
      <ul className="space-y-2.5" role="list">
        {column.children.slice(0, 5).map((item) => (
          <li key={item.id}>
            {item.url.startsWith('http') || item.url.startsWith('mailto:') || item.url.startsWith('tel:') ? (
              <a
                href={item.url}
                target={item.target || '_self'}
                rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                className="text-sm text-slate-500 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-all duration-200 hover:translate-x-0.5 inline-block"
              >
                {item.label}
              </a>
            ) : (
              <Link
                to={item.url}
                className="text-sm text-slate-500 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-all duration-200 hover:translate-x-0.5 inline-block"
              >
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
